import { apiRequest } from "PhishingManager/service/apiHelper";

const BASE_URL = process.env.REACT_APP_API_URL_REST;

export const getFeatureList = (tenantId: number) => {
    const url = `${BASE_URL}/tenantFeatures/${tenantId}`;
    return apiRequest(url);
}

export const updateTenantFeature = (tenantId: number, feature: { featureId: number, isEnabled: boolean }) => {
    const url = `${BASE_URL}/tenantFeatures/${tenantId}`;
    return apiRequest(url, { method: "PUT", body: {
        features: [feature]
    } });
};